import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

const baseRef = 'email';
const route = {
  comboPaginado: (like: string) => `${baseRef}/consultar-combo-paginado/${like}`,
  salvar: `${baseRef}`,
  alterarStatus: (id: number, status: string) => `${baseRef}/alterar-status/${id}/${status}`,
};

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  constructor(private apiService: ApiService) {}

  comboPaginado(like: string) {
    return this.apiService.get<any[]>(route.comboPaginado(like));
  }

  salvar(dto: { email: string }) {
    return this.apiService.post<any>(route.salvar, dto);
  }

  inativar(id: number, justificativaInativacao: string) {
    return this.apiService.put<any>(route.alterarStatus(id, 'Inativo'), { justificativaInativacao });
  }

  ativar(id: number) {
    return this.apiService.put<any>(route.alterarStatus(id, 'Ativo'));
  }
}
